<template lang="html">
  <div class="col-12 profile-groups-box no-pad-both">
    <NewGroup v-if="showNewGroupPopup" @close="showNewGroupPopup = false" @createNewGroup="createNewGroup"></NewGroup>

    <div id="group-empty-data" class="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12 white-box" v-if="userGroups.length == 0">
      <div><span class="material-icons" aria-hidden="true">folder_open</span></div>
      <h4>Du har endnu ikke tilføjet samlinger.</h4>
      <p>
        Her kan du tilføje dine egne samlinger, hvor du kan gruppere dine favoritter som du vil.
        Opret fx en samling med dine favorit-legepladser eller planlæg, hvor du skal hen på weekendens cykeltur.
      </p>
    </div>

    <div class="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12 add-new-profile-group white-box" @click="showNewGroupPopup = true;" tabindex="0">
      <span>Tilføj ny samling</span>
      <span class="material-icons grey-text" aria-hidden="true">add</span>
    </div>

    <div class="col-12" v-if="userGroups.length != 0">
      <template v-for="(group, index) in userGroups">
        <ProfileGroup :groupData="group"></ProfileGroup>
      </template>
    </div>

  </div>
</template>

<script>
import ProfileGroup from '@/components/profile/ProfileGroup.vue'
import Profile from '@/assets/profile/Profile.js'
import NewGroup from '@/components/profile/NewGroup.vue'

export default {
  data() {
    return {
      userGroups: false,
      showNewGroupPopup: false,
    }
  },
  components: {
    ProfileGroup, NewGroup
  },
  created() {
    Profile.getUserData().then((data) => {
      this.userGroups = data.groups;
      this.$HelperFunctions.sortArrayByString(this.userGroups, 'name');
    });
  },
  methods: {
    createNewGroup(groupName) {
      console.log('Create new group', groupName);
      this.showNewGroupPopup = false;
      Profile.createNewGroup(groupName);
    },
  }
}
</script>

<style lang="css" scoped>
  .add-new-profile-group {
    margin-top: 10px;
    height: 45px;
    line-height: 45px;
    vertical-align: middle;
    text-align: center;
    cursor: pointer;
  }

  .add-new-profile-group span:first-child {
  	font-size: 20px;
  	text-transform: uppercase;
  	color: rgb(000,112,141);
  }

  .add-new-profile-group .material-icons {
    position: relative;
  	bottom: -7px;
  	font-size: 35px;
  }

  #group-empty-data {
    margin-top: 10px;
  	padding: 10px 5px;
  	height: auto;
    text-align: center;
  }

</style>
